import { render } from "./AuthorSelect.vue?vue&type=template&id=25b6f902&scoped=true"
import script from "./AuthorSelect.vue?vue&type=script&lang=js"
export * from "./AuthorSelect.vue?vue&type=script&lang=js"

import "./AuthorSelect.vue?vue&type=style&index=0&id=25b6f902&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/zmen-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b6f902"]])

export default __exports__